import { App } from '../../App'

export default {
  install(editor) {
    const listeners = new WeakMap()
    editor.on('rendernode', ({ el, node }) => {
      if (!listeners.has(el)) {
        listeners.set(el, true)

        // Handles double-click on node
        el.addEventListener('dblclick', async (e) => {
          e.stopPropagation()

          // Handles nodes' data and modal
          await App.handleNodeData(node, editor)
  
          // Triggers 'resetconnection'
          editor.trigger('resetconnection')
        })     
      }
    })
  }
}